import * as React from "react";

interface Props extends React.SVGProps<SVGSVGElement> {
    size?: number;
}

const AddIcon = ({ size = 16, ...props }: Props) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M1.9064 9.61105L9.61119 9.61105L9.61119 1.94618C9.60574 1.77143 9.63564 1.59737 9.69909 1.43444C9.76254 1.27152 9.85825 1.12309 9.98046 0.998055C10.2452 0.733361 10.6042 0.584658 10.9785 0.584658C11.3528 0.584658 11.7118 0.733361 11.9765 0.998055C12.1012 1.11809 12.2001 1.26234 12.267 1.42194C12.3339 1.58155 12.3675 1.75316 12.3658 1.92622L12.3158 9.64099L20.0805 9.64099C20.4059 9.63743 20.7203 9.75889 20.9588 9.98032C21.2235 10.245 21.3722 10.604 21.3722 10.9784C21.3722 11.3527 21.2235 11.7117 20.9588 11.9764C20.8369 12.1089 20.6887 12.2145 20.5238 12.2867C20.3589 12.3588 20.1807 12.3959 20.0007 12.3956L12.3458 12.3457L12.3458 20.0305C12.3486 20.2019 12.3174 20.3722 12.254 20.5315C12.1906 20.6908 12.0963 20.836 11.9765 20.9587C11.7118 21.2233 11.3528 21.372 10.9785 21.372C10.6042 21.372 10.2452 21.2233 9.98046 20.9587C9.85577 20.8386 9.75693 20.6944 9.69 20.5348C9.62306 20.3752 9.58945 20.2035 9.59123 20.0305L9.64113 12.3157L1.87646 12.3157C1.55104 12.3193 1.23667 12.1978 0.998192 11.9764C0.733498 11.7117 0.584795 11.3527 0.584795 10.9784C0.584795 10.604 0.733498 10.245 0.998192 9.98032C1.24071 9.74379 1.56707 9.61105 1.9064 9.61105Z"
            fill={props.color || "currentColor"}
        />
    </svg>
);
export default AddIcon;
